/* eslint-disable
    no-param-reassign,
    no-undef,
    prefer-rest-params,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.factory('debouncer', ($q) => {
    const getWait = function (wait) {
        if (typeof wait === 'function') { return wait() } return wait
    }

    const defer = function () {
        const deferred = {}
        deferred.promise = $q((resolve, reject) => {
            deferred.resolve = resolve
            return (deferred.reject = reject)
        })
        return deferred
    }

    const debounce = function (fn, wait, options) {
        wait = wait || 0
        options = options || {}
        let lastCallAt
        let deferred
        let timer
        let pendingArgs = []
        let counter = 0

        const flush = function () {
            const thisDeferred = deferred
            if (timer) {
                clearTimeout(timer)
            }
            if (options.accumulate) {
                fn.call(this, pendingArgs).then((res) => thisDeferred.resolve(res)).catch((err) => thisDeferred.reject(err))
            } else {
                fn.apply(this, pendingArgs[pendingArgs.length - 1]).then((res) => thisDeferred.resolve(res)).catch((err) => thisDeferred.reject(err))
            }
            pendingArgs = []
            deferred = null
            counter += 1
            return counter
        }

        return function () {
            const currentWait = getWait(wait)
            const currentTime = new Date().getTime()

            const isCold = !lastCallAt || ((currentTime - lastCallAt) > currentWait)

            lastCallAt = currentTime

            if (isCold && options.leading) {
                return options.accumulate ? fn.call(this, [arguments]).then(result(() => result[0])) : fn.call(this, arguments)
            }

            if (deferred) {
                clearTimeout(timer)
            } else {
                deferred = defer()
            }

            pendingArgs.push(arguments)
            if (options.debounceAfter && (counter < options.debounceAfter)) {
                timer = setTimeout(flush.bind(this), 0)
            } else {
                timer = setTimeout(flush.bind(this), currentWait)
            }

            if (options.accumulate) {
                const argsIndex = pendingArgs.length - 1
                return deferred.promise.then(results(() => results[argsIndex]))
            }

            return deferred.promise
        }
    }

    return {
        debounce,
    }
})
